<template>
  <div class="abc-culture">
      <div class="banner"><img src="./banner-culture.jpg" alt="" width="100%"></div>
      <div class="culture-main">
        <p class="tit clearfix">
            <span><a href="/">首页</a></span>
            <span class="arr-blue">&gt;</span>
            <span class="font-blue">亚商文化</span>
        </p>
        <div class="content">
            <p class="title">我们的理念：</p>
            <p class="text">通过打造集投资、咨询和行业研究为一体的生态服务圈，为客户实现非凡投资回报的同时也挖掘并助力越来越多的企业走向卓越，是我们每一个亚商人所坚信的使命和理念</p>
            <p class="title">我们的价值观：</p>
            <div class="slide-list">
                <div class="slide" v-for="(item, index) in slideList" :key="item.id">
                    <div class="clearfix">
                        <!-- <img class="fl" :src="item.icon" alt="" width="64"> -->
                        <span class="summary fl">{{item.summary}}</span>
                        <span class="slideToggle fr" :class="{'slideUp': item.iSlideDown && item.id == clickIndex}" ></span> <!--  @click="slideToggle(index)" -->
                    </div>
                    <transition name="slideText">
                        <p class="text" >{{item.text}}</p>  <!-- v-show="item.iSlideDown && item.id == clickIndex" -->
                    </transition>
                </div>
            </div>
        </div>
      </div>
      <go-top></go-top>
  </div>
</template>
<script>
import icon1 from './zhuanye.png'
import icon2 from './zeren.png'
import icon3 from './xiezuo.png'
import icon4 from './chuangxin.png'
import goTop from "../../common/go-top.vue";

export default {
  name: 'Culture',
  components: {
    goTop
  },
  data () {
      return {

          clickIndex: 0,
          slideList: [
              {
                  id: 0,
				  iSlideDown: false,  //true 是点开
                  icon: icon1,
                  summary: '专 业',
                  text: '在亚商，我们坚信“魔鬼在细节”。专业严谨的工作态度，是我们三十年来持之以恒的运营核心。'
              },
              {
                  id: 1,
				  iSlideDown: false,
                  icon: icon2,
                  summary: '责 任',
                  text: '责无旁贷，是亚商人所需要具备的基本品质。无论是面对客户、合作伙伴还是同事员工，我们都坚持做到勇于承担责任，兑现信守的承诺。'
              },
              {
                  id: 2,
				  iSlideDown: false,
                  icon: icon3,
                  summary: '协 作',
                  text: '团队合作永远是一个成功企业的必备品质。亚商坚持打造合理高效的跨部门团队协调机制，让员工互相之间形成优势互补，实现1+1>2的最佳效果。'
              },
              {
                  id: 3,
				  iSlideDown: false,
                  icon: icon4,
                  summary: '创 新',
                  text: '作为中国最早的一批民营企业，亚商信奉开拓创新的企业家精神。永不停息的创新是一个企业保持长期竞争力的关键要素。'
              }
          ]
      }
  },
  updated: function () {

    },
  methods: {
    slideToggle: function(index){
		if(this.clickIndex !=index){ //当前点击和上一次点击的不同
			if(this.slideList[this.clickIndex].iSlideDown){ //且上一个点击的是开启状态
				this.slideList[this.clickIndex].iSlideDown = false;  //收缩上次点击的节点
			}else{ //已经是收缩的不处理

			}
		}
        this.slideList[index].iSlideDown =!this.slideList[index].iSlideDown;

        this.clickIndex = index;
    }
  }
}
</script>

<style scoped>
.abc-culture {
    min-width: 1200px;
}
.abc-culture .banner{
    width: 100%;
}
.culture-main{
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 48px;
}
.abc-culture .tit{
    height: 46px;
    line-height: 46px;
    font-size: 14px;
}
.abc-culture .tit span{
    float: left;
    padding: 0 4px;
    cursor: pointer;
    color: #333;
}
.abc-culture .tit a{
    color: #333;
}
.abc-culture .tit .font-blue{
    color: #003B83;
}
.abc-culture .arr-blue{
    /* color: #003B83; */
    font-weight: 600;
}
.content{
    background: #fff;
    padding: 40px 92px;
    text-align: center;
    border: 1px solid #ced7e2;
}
.content .title{
    font-size: 20px;
    text-align: left;
    margin-bottom: 20px;
}
.content .title,.content .slide .summary{
    font-weight: 600;
    color: #003B83;
}
.content .text{
  color: #666;
  line-height: 24px;
  text-align: justify;
  margin-bottom: 42px;
}
.content .slide{
    padding: 18px;
    border-bottom: 1px solid #E2E7EE;
}
.content .slide img{
    vertical-align: middle;
    margin-right: 15px;
}
.content .slide span{
    display: inline-block;
    height: 100%;
}
.content .slide .summary{
    font-size: 20px;
    line-height: 64px;
}
.content .slide .slideToggle{
    /* background: url('./slide-down.png') no-repeat 0 0;
    width: 50px;
    height: 50px;
    cursor: pointer;
    transition: all 0.5s; */
}
.content .slide .slideUp{
    background: url('./slide-up.png') no-repeat 0 0;
}
.content .slide .text{
    padding-left: 80px;
    margin-bottom: 0;
    margin-top: 10px;
    /* max-height: 58px; */
    /* height: 0px; */
}
/* .slideText-enter-active{
    transition: all 0.5s;
    max-height: 58px;
}
.slideText-leave-active{
    transition: all 0.5s;
    height: 0;
}
.slideTextText-enter{
    height: 0;
}
.slideText-leave{
    max-height: 58px;
} */
.slideText-enter-active,.slideText-leave-active{
    transition: opacity 0.1s;
}
.slideText-enter,.slideText-leave-to{
    opacity: 0;
}
.slideText-enter-to,.slideText-leave{
    opacity: 1;


}

</style>





// WEBPACK FOOTER //
// src/components/culture/Culture.vue